const i18n = {
  'zh-CN': {
    spread: '展开',
    packUp: '收起',
    search: '查询',
    reset: '重置'
  },
  'en': {
    spread: 'Unfold',
    packUp: 'Fold',
    search: 'Query',
    reset: '重置'
  }
}
export default i18n
